import './RowNumberColumn.css';

const RowNumberColumn = ({ rowCount }) => {
  const handleCopy = (event) => {
    event.preventDefault();
  };

  return (
    <div className="row-number-column non-copyable-column" aria-hidden="true" onCopy={handleCopy}>
      <div className="row-number-header">Item</div>
      {Array.from({ length: rowCount }, (_, i) => (
        <div key={i} className="row-number-cell">
          <span>{i + 1}</span>
        </div>
      ))}
      <div className="row-number-footer" />
    </div>
  );
};

export default RowNumberColumn;
